export default __webpack_public_path__ + "static/media/2_0130.2b35313e.webp";